import { FC, ReactNode, createContext, useContext, useState } from 'react';

import { TabKey } from '@utils/constants/home';

type HomeTabsContextType = {
  activeTab: TabKey;
  setActiveTab: (tab: TabKey) => void;
};

type HomeTabsContextProvider = {
  children: ReactNode;
};

export const HomeTabsContext = createContext<HomeTabsContextType>({
  activeTab: TabKey.Suggested,
  setActiveTab: () => {},
});

export const useHomeTabs = () => {
  const context = useContext(HomeTabsContext);
  if (!context)
    throw new Error('useHomeTabs must be used within HomeTabsProvider');
  return context;
};

export const HomeTabsProvider: FC<HomeTabsContextProvider> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<TabKey>(TabKey.Suggested);

  return (
    <HomeTabsContext.Provider
      value={{
        activeTab,
        setActiveTab,
      }}
    >
      {children}
    </HomeTabsContext.Provider>
  );
};
